import { render, staticRenderFns } from "./YChip.vue?vue&type=template&id=776744b6&scoped=true&lang=pug&"
import script from "./YChip.vue?vue&type=script&lang=js&"
export * from "./YChip.vue?vue&type=script&lang=js&"
import style0 from "./YChip.vue?vue&type=style&index=0&id=776744b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776744b6",
  null
  
)

export default component.exports